module.exports = __webpack_public_path__ + "static/media/IconShield.aae207dd.svg";